import { render, staticRenderFns } from "./Abstract.vue?vue&type=template&id=644f3d57&scoped=true&"
import script from "./Abstract.vue?vue&type=script&lang=js&"
export * from "./Abstract.vue?vue&type=script&lang=js&"
import style0 from "./Abstract.vue?vue&type=style&index=0&id=644f3d57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644f3d57",
  null
  
)

export default component.exports